import { UserOutlined } from "@ant-design/icons";
import React from "react";
import styled from "styled-components";

const UserAvatar = ({
  size = 64,
  name = null,
  surname = null,
  isVisibleInSmall = false,
}) => {
  const handleAvatarName = () => {
    if (name) {
      if (surname) {
        return `${name[0]?.toUpperCase()} ${surname[0]?.toUpperCase()}`;
      } else {
        return `${name[0]?.toUpperCase()}${name[1].toLowerCase()}`;
      }
    } else if (surname) {
      return `${surname[0]?.toUpperCase()}${surname[1].toLowerCase()}`;
    } else {
      return <UserOutlined />;
    }
  };

  return (
    <Avatar $size={size} $isVisibleInSmall={isVisibleInSmall}>
      {handleAvatarName()}
    </Avatar>
  );
};

export default UserAvatar;

const Avatar = styled.div`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  background-color: #373b4014;
  border-radius: 50%;
  border: 2px solid #373b4014;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #373b405f;
  font-size: ${({ $size }) => $size / 2}px;

  @media only screen and (max-width: 808px) {
    display: ${({ $isVisibleInSmall }) =>
      $isVisibleInSmall ? "flex" : "none"};
  }
`;
